module.exports = "<p>\r\n  register-of-fine works!\r\n</p>\r\n"